/**
 * Themes: Index
 *
 * Este arquivo exporta todos os temas disponíveis na aplicação.
 * Segue o princípio do Atomic Design como parte da organização de temas.
 */

import lightTheme from './light';
import escuroTheme from './mensure-dark';

// Objeto com todos os temas disponíveis
export const themes = {
  [lightTheme.id]: lightTheme,
  [escuroTheme.id]: escuroTheme,
};

// Lista de temas para seleção
export const themesList = [
  { id: lightTheme.id, name: lightTheme.name },
  { id: escuroTheme.id, name: escuroTheme.name },
];

// Tema padrão
export const defaultTheme = escuroTheme;

export default themes;
